export enum AnalyticsEvents {
  PartnerClick = 'partner_click',
  CategoryView = 'category_view',
  SelectCard = 'ab_select_card',
  SearchAutocomplete = 'ab_search',
  ShowMoreClick = 'show_more_click',
  SearchFocus = 'search_focus',
  ExitPage = 'exit_page',
  PageView = 'page_view',
  UniqueUser = 'unique_user',
  LogIn = 'log_in',
  RequestDiscountFormSubmit = 'ab_request_discount_form_submit',
  RequestDiscountButtonClick = 'ab_request_discount_button_click',
  GetPromocodeButtonClick = 'ab_get_promocode_button_click',
  AddToFavoriteButtonClick = 'ab_add_favorite_button_click',
  LikeButtonClick = 'ab_like_button_click',
  DislikeButtonClick = 'ab_dislike_button_click',
}
